<template>
  <widget edge :disabled="true" class="bg-success text-white text-center border-0" name="prayer-countdown" 
  title="Prayer Countdown"
  img="data:image/svg+xml;utf8;base64,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">
    <template v-if="currentPrayer">
    <button slot="toolbar-button" class="btn btn-outline-light" @click="toggle" v-text="stop ? 'Start' : 'Stop'"></button>
    
    <template v-if="position">
     <div class="alert text-light font-weight-bold p-1 m-0">
      <span class="h5 border-bottom">{{ prayer.name | readable }} at {{ prayer.date | format('LT') }}</span>
    </div>

    <countdown :stop="stop" :end="delayed"></countdown>
    </template>
    <br/>
    <blockquote class="blockquote">
      <p class="mb-0">"The best of deeds in the sight of Allah is salah at the beginning of its time"</p>
      <footer class="blockquote-footer text-black-50"><cite title="Source Title">(Sahih Bukhari)</cite></footer>
    </blockquote> 
    
    <div slot="footer" v-show="playing" class="alert alert-success m-0 rounded-0" role="alert">
      <audio ref="adhanPlayer" @play.native="onPlay" src="/assets/adhan-makka.mp3" controls="controls">
        <span>Your browser doesn't support HTML5 audio, Adhan will not be played.</span>
      </audio>
      <button type="button" class="close" aria-label="Close" @click="stopAdhan">
        <span aria-hidden="true">&times;</span>
      </button>
    </div>
    </template>
  </widget>
</template>

<script>
import Countdown from "@/Countdown.vue";
import moment from "moment";

var LEEWAY_MINUTES = 5*60*1000;
var ADHAN_LEEWAY = 2*60*1000;
export default {
  components: {
    Countdown
  },

  computed: {
    currentPrayer() {
      return this.$store.getters.currentPrayerNameAndTime;
    },

    position() {
      return this.$store.state.location;
    },

    current() {
      if(!this.currentPrayer) return null;
      return this.currentPrayer[0];
    },

    next() {
      if(!this.currentPrayer) return null;
      return this.currentPrayer[1];
    },

    prayer() {
      if(this.delayed) { // delay passed, so we will show the next
        return this.next; 
      } else {
        return this.current;
      }
    },

    delayed() {      
      let date = this.current.date;
      if(!this.current.date) { // this happens in the fajr
        return this.next.date;
      }
      if((new Date() - date) > this.leeway) {
        if(this.autoStopped) {
          this.stop = false;
          this.autoStopped = false;
        }

        return this.next.date;
      } else {
        console.log('leeway bad');
        this.autoStopped = true;
        // console.log('NOT at least leeway');
        return null;
      }
    }
  },

  data() {
    return {
      playing: false,
      leeway: LEEWAY_MINUTES,
      stop: false,
      autoStopped: false
    };
  },

  watch: {
    next(val, old) {
      if (old && val.name !== old.name) { // watch triggers even when values are same :(
        this.stop = true; // stop the count down for a short time
        console.log("time changed", val, old);
        if((new Date() - old.date) < ADHAN_LEEWAY) { // safe guard from playing adhan when visited 
          if(['midnight', 'sunrise', 'fajr', 'sunset'].indexOf(val.name) === -1) {
             console.log('in next, condition meet: ', val, old);
            this.playAdhan();
          }
        } 
      }
    }
  },

  mounted() {
    // this.$refs.adhanPlayer.addEventListener('play', (el) => {
    //   if((new Date() - this.current.date) > ADHAN_LEEWAY) {
    //     console.log('paushed');
    //     // stop
    //     this.$refs.adhanPlayer.pause(); // prevent from playing
    //     this.playing = false;
    //   }
    //   console.log('event listner', el.target);
    // });

    // this.$refs.adhanPlayer.addEventListener('ended', (el) => {
      
    // });

    window.onfocus = () => {
      console.log('window is now focused.');
      this.leeway = 0;
      this.stop = false;
    }
  },

  methods: {
    onPlay(el) {
      console.log('play event', el.target);
    },

    playAdhan() {
      console.log("call to adhan...");

      // if((new Date() - val.date) < ADHAN_LEEWAY) { // safe guard from playing adhan when visited 
      //   if(['midnight', 'sunrise', 'fajr', 'sunset'].indexOf(val.name) === -1) {
      //     console.log('in next, condition meet in playAdahn: ', val, old);
          this.playing = true;
          this.$refs.adhanPlayer.currentTime = 0;
          this.$refs.adhanPlayer.play();

          setTimeout(() => {
            this.stopAdhan();
          }, 30000);
        // }
      // } 
      
      
      
    },

    stopAdhan() {
      this.playing = false;
      this.$refs.adhanPlayer.pause();
      this.$refs.adhanPlayer.currentTime = 0;
    },

    toggle() {
      console.log('start/stop', this.stop);
      if(this.stop) {
        this.leeway = 0;
        this.stop = false;
      } else {
        this.leeway = LEEWAY_MINUTES;
        this.stop = true;
      }
      console.log('start/stop', this.stop, this.leeway);
    }
  }
};
</script>

<style type="scss" scoped>
blockquote.blockquote {
  font-size:1em;
}


.card-body {
  padding:0;
}
</style>




// WEBPACK FOOTER //
// src/widgets/PrayerCountdown.vue